import React from 'react';
import { motion } from 'framer-motion';
import EcosystemMindMap from './EcosystemMindMap';

const EcosystemHero = () => {
  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden bg-white">
      {/* Futuristic Power Grid Background */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {/* The Moving Grid Base */}
        <motion.div 
          initial={{ backgroundPosition: '0 0' }}
          animate={{ backgroundPosition: ['0px 0px', '40px 40px'] }}
          transition={{ duration: 4, repeat: Infinity, ease: "linear" }}
          className="absolute inset-0 opacity-[0.15]"
          style={{ 
            backgroundImage: `
              linear-gradient(to right, #4f46e5 1px, transparent 1px),
              linear-gradient(to bottom, #4f46e5 1px, transparent 1px)
            `,
            backgroundSize: '40px 40px',
            maskImage: 'radial-gradient(circle at center, black 30%, transparent 80%)',
            WebkitMaskImage: 'radial-gradient(circle at center, black 30%, transparent 80%)'
          }}
        />

        {/* Scanning Power Lines */}
        <motion.div 
          animate={{ y: ['-100%', '200%'] }}
          transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
          className="absolute inset-x-0 h-[2px] bg-gradient-to-r from-transparent via-indigo-500/30 to-transparent z-0"
        />
        <motion.div 
          animate={{ x: ['-100%', '200%'] }}
          transition={{ duration: 12, repeat: Infinity, ease: "linear", delay: 2 }}
          className="absolute inset-y-0 w-[2px] bg-gradient-to-b from-transparent via-blue-500/20 to-transparent z-0"
        />

        {/* Dynamic Glow Orbs */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-[800px] bg-[radial-gradient(circle_at_center,_#4f46e512_0%,_transparent_70%)]" />
        <motion.div 
          animate={{ 
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.5, 0.3]
          }}
          transition={{ duration: 8, repeat: Infinity }}
          className="absolute -top-24 -left-24 w-[500px] h-[500px] bg-indigo-100/40 rounded-full blur-[120px]" 
        />
        <motion.div 
          animate={{ 
            scale: [1.2, 1, 1.2],
            opacity: [0.3, 0.5, 0.3]
          }}
          transition={{ duration: 10, repeat: Infinity }}
          className="absolute -bottom-24 -right-24 w-[500px] h-[500px] bg-blue-100/40 rounded-full blur-[120px]" 
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-slate-900 text-white text-[10px] font-black uppercase tracking-[0.2em] mb-8 border border-white/10 shadow-xl shadow-indigo-100">
               ⚡ The Integrated Suite For Success
            </span>
            <h1 className="text-5xl md:text-8xl font-black text-slate-900 tracking-tighter leading-[0.9] mb-8">
              Experience the <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 via-blue-600 to-violet-600">
                Full Event Ecosystem.
              </span>
            </h1>
            <p className="text-xl text-slate-500 leading-relaxed max-w-2xl mx-auto font-medium">
              A high-performance constellation of features and products designed to work in perfect harmony with any Event. Hover to explore the deep capabilities of the BookMeIn.Events network.
            </p>
          </motion.div>
        </div>

        <EcosystemMindMap />
      </div>
    </section>
  );
};

export default EcosystemHero;